import request from '@/util/request';

export const getFeePayList = (feeId) => {
  return request({
    url: '/api/feeBack/feereturn/feePayListForApply',
    method: 'get',
    params: {
      feeId,
    },
  });
};

export const applyFeeReturn = (applyData) => {
  return request({
    url: '/api/feeBack/feereturn/apply',
    method: 'post',
    data: applyData,
  });
};
